"use client";

import { useEffect, useState } from "react";

/**
 * A `blob:` URL for a file the browser holds (a picked image to crop, say).
 * The URL is revoked when the blob changes or the component unmounts, so the
 * file is not pinned in memory for the rest of the session.
 */
export function useObjectUrl(blob: Blob | null): string | null {
	const [url, setUrl] = useState<string | null>(null);

	useEffect(() => {
		if (!blob) {
			return;
		}
		const objectUrl = URL.createObjectURL(blob);
		setUrl(objectUrl);
		return () => {
			URL.revokeObjectURL(objectUrl);
			setUrl(null);
		};
	}, [blob]);

	return blob ? url : null;
}
